import Vue from 'vue';
import VueProgressBar from 'vue-progressbar';

Vue.use(VueProgressBar, {
	color: '#03A9F4',
	failedColor: '#F44336',
	thickness: '3px'
});